<template>
  <transition name="notification-small-slide-in">
    <div v-if="notification.Event == 'message' || notification.DisplayType === 'push'" class="notification-small">
      <div class="close-btn" @click="$emit('closeNotification', notification)"></div>
      <div v-if="notification.ImageUrl && notification.Event !== 'inbox'" class="image-wrapper">
        <img :src="notification.ImageUrl" />
      </div>
      <div>
        <div class="title">{{notification.Title}}</div>
        <div v-if="notification.Event === 'inbox'" class="preview">{{notification.PreviewText}}</div>
        <div v-if="notification.Event === 'message'" class="preview" v-html="notification.Message"></div>
        <div v-if="notification.Event === 'inbox'" @click="$emit('readMoreClicked', notification)" class="show-message-button">{{translations.readMore}}</div>
        <a v-if="notification.Event !== 'inbox' && notification.CTAButtonText && notification.CTAButtonLink" :href="notification.CTAButtonLink" @click.prevent="$emit('hrefClicked', {data: notification, href: notification.CTAButtonLink})" class="show-message-button">{{notification.CTAButtonText}}</a>
        <a v-if="notification.Event !== 'inbox' && notification.CTAButton2Text && notification.CTAButton2Link" :href="notification.CTAButton2Link" @click.prevent="$emit('hrefClicked', {data: notification, href: notification.CTAButton2Link} )" class="show-message-button secondary">{{notification.CTAButton2Text}}</a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NotificationSmall',
  props: {
    notification: {
      type: Object,
    },
    translations: {
      type: Object,
    },
  },
};
</script>

<style lang="less">
#fasttrack-crm {
  .notification-small {
    box-sizing: border-box;
    font-family: "Lato", sans-serif;
    border-radius: 4px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    margin-bottom: 15px;
    padding: 20px 20px 10px 20px;
    position: relative;
    transition: all 0.6s;
    transition-timing-function: cubic-bezier(0.45, 0.05, 0.55, 0.95);
    display: flex;

    .image-wrapper {
      img {
        width: 100px;
        height: auto;
        display: block;
        margin-right: 10px;
      }
    }

    .title {
      font-size: 20px;
      color: #000;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .preview {
      margin: 0;
      padding: 3px 20px 10px 0px;
      display: block;
      min-height: 25px;
      font-size: 14px;
      line-height: 1.2;
      letter-spacing: -0.1px;
      color: #000;
      margin-bottom: 10px;

      a {
        color: #2d72ee;
      }
    }

    .show-message-button {
      background-color: #0e9543;
      border-radius: 4px;
      color: #fff;
      display: inline-block;
      padding: 15px 23px 15px;
      text-transform: uppercase;
      font-size: 12px;
      cursor: pointer;
      position: relative;
      text-decoration: none;
      margin: 0px 10px 10px 0px;
      text-align: center;

      &:hover {
        &:before {
          background-color: rgba(0, 0, 0, 0.15);
        }
      }

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-radius: 4px;
        transition: all 0.2s linear;
      }

      &.secondary {
        background-color: #f6cd34;
        color: #141100;
      }
    }
  }

  .notification-small-slide-in-enter,
  .notification-small-slide-in-leave-to {
    opacity: 0;
    transform: translate(500px, 0px);
  }

  .notification-small-slide-in-leave,
  .notification-small-slide-in-leave-to,
  .notification-small-slide-in-leave-active {
    transition: all 0.2s;
  }
}
</style>
